import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/index/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import("../views/index/index"),
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/index/home/index'),
        name: 'home',
      },
      {
        path: 'train',
        component: () => import('@/views/train/index'),  
        name: '训练',
      },
      {
        path: 'article',
        component: () => import('@/views/article/index'),
        name: 'article',
      },
      {
        path: 'course',
        component: () => import('@/views/course/index'),
        name: '课程',
      },
     
      {
        path: 'read',
        component: () => import('@/views/read/index'),
        name: '阅读',
      },
      {
        path: 'petition',
        component: () => import('@/views/petition/index'),
        name: '比赛',
      },
     
      {
        path: 'examination',
        component: () => import('@/views/examination/index'),
        name: '考试',
      },
      {
        path: 'information',
        component: () => import('@/views/index/information'),
        name: '我的信息',
      },
      {
        path: 'statistics',
        component: () => import('@/views/index/statistics'),
        name: '统计',
      },
      {
        path: 'opinion',
        component: () => import('@/views/index/opinion'),
        name: '意见反馈',
      },
    ]
  },

  // 横向运动
  {
    path: "/heng",
    name: "heng",
    component: () => import("../views/train/componet/heng.vue"),
  },
  // 纵向运动
  {
    path: "/zongxiang",
    name: "zongxiang",
    component: () => import("../views/train/componet/zongxiang.vue"),
  },

  // 8字舞 dance
  {
    path: "/baziwu",
    name: "8字舞",
    component: () => import("../views/train/componet/baziwu.vue"),
  },
   // 火眼金睛
  // {
  //   path: "/duixiaoxian",
  //   name: "火眼金睛",
  //   component: () => import("../views/train/componet/duixiaoxian.vue"),
  // },
   // 明察秋毫  
  //  {
  //   path: "/mingChaQiuHao",
  //   name: "明察秋毫",
  //   component: () => import("../views/train/componet/mingChaQiuHao.vue"),
  // },
  //  {
  //   path: "/liLizaimu",
  //   name: "历历在目",
  //   component: () => import("../views/train/componet/liLizaimu.vue"),
  // },
  // {
  //   path: "/feizuojiyou",
  //   name: "非左即右",
  //   component: () => import("../views/train/componet/feizuojiyou.vue"),
  // },
  // {
  //   path: "/fenbianshifei",
  //   name: "分辨是非",
  //   component: () => import("../views/train/componet/fenbianshifei.vue"),
  // },
  // {
  //   path: "/mofafuyuan",
  //   name: "魔法复原",
  //   component: () => import("../views/train/componet/mofafuyuan.vue"),
  // },
  {
    path: "/cecaidingwei",
    name: "色彩定位",
    component: () => import("../views/train/componet/cecaidingwei.vue"),
  },
  
  {
    path: "/flash",
    name: "字符快闪",
    component: () => import("../views/train/componet/flash.vue"),
  },
  
  {
    path: "/endSharing",
    name: "endSharing",
    component: () => import("../views/components/endSharing.vue"),
  },
  {
    /* 听音乐 */
    path: "/music",
    name: "music",
    component: () => import("../views/course/music/index.vue"),
  },
  {
    path: '/start',
    component: () => import("../views/petition/components/start.vue"),
    name: '/start',
  },
  {
    path: '/EndPage',
    component: () => import('@/views/petition/components/EndPage'),
    name: '比赛结束成绩页面',
  },
  {
    path: '/completed',
    component: () => import("../views/read/components/completed.vue"),
    name: '阅读答题结束',
  },
  {
    path: '/exaComponen',
    component: () => import("../views/examination/components/exaComponen.vue"),
    name: '考试结束',
  },
  {
    path: '/endExam',
    component: () => import("../views/examination/components/endExam.vue"),
    name: '考试结束1',
  },
  {
    path: '/game',
    component: () => import("../views/ge/game.vue"),
    name: '游戏主组件',
  },
  {
    path: '/courseGames',
    component: () => import('../views/course/courseGames.vue'),
    name: '课程游戏',
  },
  {
    path: '/achievement',
    component: () => import('../views/course/achievement.vue'),
    name: '课程成绩',
  },
  {
    path: '/yuedudati',
    component: () => import("../views/read/components/yuedudati.vue"),
    name: '阅读答题',
  },

  {
    path: '/exStart',
    component: () => import("../views/examination/components/exStart.vue"),
    name: '考试页面',
  },
  {
    path: '/petiDetails',
    component: () => import("../views/petition/details.vue"),
    name: '考试页面1',
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});



// 重复点击控制台报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;
